import { useTranslation } from 'react-i18next';

import type { CadeExpansion } from '@/services/types';

/**
 * What the search added to the query, said before the results.
 *
 * The thesaurus widens a query only with other names for the same thing in this field (THC2 and
 * SSE, an abbreviation and its expansion). Nothing is added silently: each group is listed with
 * the term the reader typed, and a quoted term is searched alone.
 */
export function ThesaurusNotice({ groups }: { groups: CadeExpansion[] }) {
  const { t } = useTranslation(['cade']);
  if (groups.length === 0) return null;
  return (
    <div className="space-y-1" data-thesaurus>
      {groups.map((group) => (
        <p
          key={group.key}
          role="note"
          className="rounded-md border bg-muted/40 p-2 text-xs text-foreground"
        >
          {t('cade:thesaurus.notice', { matched: group.matched, also: group.also.join(', ') })}
        </p>
      ))}
    </div>
  );
}
